import React from 'react';
import * as S from './GoSafeMeasures.styles';

const GoSafeMeasures = (props) => {
    const { data, headerMsg } = props.data;
    const goSafeIcon = "https://gos3.ibcdn.com/gosafesmall-1589464635.png";

    return (
        <S.GoSafeWrap>
            <S.GoSafeTitle>{headerMsg}</S.GoSafeTitle>
            <S.GoSafeHeader>
                <img src={goSafeIcon} width='35px' />
                <span>Safety Measures</span>
            </S.GoSafeHeader>
            <div>
                <S.GoSafeCarouselUL>
                    {data && data.length ?
                        data.map((item, index) => {
                            const { title, message, logo_url, key_points } = item.banner_content.json_value;
                            if (key_points && key_points.length) {
                                return (<S.GoSafeCarouselLI key={index + item.name}>
                                    <div style={{ width: "70%", float: "left" }}>
                                        <S.CardHeader>{title}</S.CardHeader>
                                        <ul style={{ listStyle: 'disc', paddingLeft: "20px" }}>
                                            {key_points.map((point, index) => {
                                                return (
                                                    <li key={point + index} >
                                                        {point}
                                                    </li>)
                                            })}
                                        </ul>
                                        <S.CardInfo>{message}</S.CardInfo>
                                    </div>
                                    <img src={logo_url} alt="" width='70px' height='70px' />
                                </S.GoSafeCarouselLI>
                                )
                            }
                            return (<S.GoSafeCarouselLI key={index + item.name}>
                                <S.CardContent>
                                    <S.CardHeader>{title}</S.CardHeader>
                                    <S.CardInfo>{message}</S.CardInfo>
                                </S.CardContent>
                                <img src={logo_url} alt="" width='70px' />
                            </S.GoSafeCarouselLI>
                            )
                        })
                        : null}

                </S.GoSafeCarouselUL>
            </div>
        </S.GoSafeWrap>
    );
}
export default GoSafeMeasures;
